module.exports = __webpack_public_path__ + "static/img/fun2.cf0dd46d.png";